<button
  class="mr-3 search-order"
  nz-button
  nz-dropdown
  nzSize="small"
  nzTrigger="click"
  [nzNoAnimation]="true"
  [nzDropdownMenu]="orderMenu"
  [ngClass]="{'mr-3': !notMarginRight}"
>
  <svg width="16" height="25" viewBox="0 0 16 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 5.33334L12 9.33334H4L8 5.33334Z" fill="#EB194B"/>
    <path d="M8 20L4 16L12 16L8 20Z" fill="#EB194B"/>
  </svg>
    
  {{(order$ | async)?.label || 'Ordenar'}}
  <span nz-icon nzType="down" class="arrow-select"></span>
</button>

<nz-dropdown-menu #orderMenu="nzDropdownMenu">
  <div nz-menu class="order-menu">
    <nz-radio-group
      [ngModel]="order"
      (ngModelChange)="changeOrder($event)"
    >
      <label
        *ngFor="let orderType of orderTypes"
        nz-menu-item
        nz-radio
        [nzValue]="orderType"
      >
        {{orderType.label}}
      </label>
    </nz-radio-group>
  </div>
</nz-dropdown-menu>
